import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'how_many_languages_must_be_spoken_supervisors_management'

export const dataPointDefinition = {
  retracedId: 'how_many_languages_must_be_spoken_supervisors_management',
  name: 'How many languages must be spoken by supervisors and management in order to effectively communicate with ALL workers? ',
  description:
    'This question relates to workers and supervisors, and includes the language(s) used by local workers and supervisors, as well as all languages used by foreign or domestic migrant workers. ',
  meta: {
    slcpMeta: {
      key: 'fp-lan-1',
      number: 'FP-LAN-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-lan-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27710,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
